var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import { Row } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import { H4 } from "@irati/ui/src/Typography";
import Button from "@irati/ui/src/Button";
import HR from "@irati/ui/src/Layout/Hr";
import { Para } from "@irati/ui/src/Labels/index";
import { brand } from "@irati/ui/src/global/colors";
import id from "@irati/utils/id";
import Flex from "@irati/ui/src/Flex";
var CompanyValueInfo = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var StyledPara = styled(Para)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var textBreak = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  word-break: break-all;\n  word-break: break-word;\n"], ["\n  word-break: break-all;\n  word-break: break-word;\n"])));
var StyledH4 = styled(H4)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  padding-right: 5px;\n  ", "\n"], ["\n  display: inline-block;\n  padding-right: 5px;\n  ", "\n"])), textBreak);
var StyledTag = styled(H4)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n  ", "\n"], ["\n  color: ", ";\n  display: inline-block;\n  ", "\n"])), brand.default, textBreak);
var TextWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-bottom: 5px;\n"], ["\n  margin-bottom: 5px;\n"])));
var MarginButton = styled(Button)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-right: 20px;\n"], ["\n  margin-right: 20px;\n"])));
var CompanyValueRow = /** @class */ (function (_super) {
    __extends(CompanyValueRow, _super);
    function CompanyValueRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyValueRow.prototype.render = function () {
        var _a = this.props, archiveCompanyValue = _a.archiveCompanyValue, editCompanyValue = _a.editCompanyValue, companyValue = _a.companyValue;
        return (React.createElement(Row, null,
            React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", marginBottom: 2 },
                React.createElement(CompanyValueInfo, null,
                    React.createElement(TextWrapper, null,
                        React.createElement(StyledH4, null, companyValue.name),
                        React.createElement(StyledTag, null,
                            "(#",
                            companyValue.tag,
                            ")")),
                    React.createElement(TextWrapper, null,
                        React.createElement(StyledPara, null, companyValue.desc))),
                React.createElement(Flex, { alignItems: "center", justifyContent: "center" },
                    React.createElement(MarginButton, { small: true, id: id("editButton", this.props), onClick: editCompanyValue },
                        React.createElement(FormattedMessage, { id: "admin.companyValues.list.edit" })),
                    React.createElement(Button, { small: true, id: id("archiveButton", this.props), onClick: archiveCompanyValue },
                        React.createElement(FormattedMessage, { id: "admin.companyValues.list.archive" })))),
            React.createElement(HR, null)));
    };
    return CompanyValueRow;
}(PureComponent));
export default CompanyValueRow;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
